import PasswordControl from './password-control';

export default PasswordControl;